<template>
  <div class="d-inline">
    <select class="custom-select" v-model="selected" @change="$emit('changeSelected', $event.target.value)">
      <option v-for="(option, key) in options" :value="key">{{translateIfOptionString(option)}}</option>
    </select>
    <button
      :class="['all-records', { clicked: isShowAllRecordsButtonClicked }]"
      @click="handleClick"
      :disabled="isShowAllRecordsButtonClicked">
      {{I18n.t('filters.date.future_dates_range.all')}}
    </button>
  </div>
</template>

<script>
  export default {
    name: 'Filters',
    props: {
      isShowAllRecordsButtonClicked: Boolean,
      options: Object,
    },
    data() {
      return {
        selected: '50',
      };
    },
    methods: {
      handleClick() {
        this.selected = 0;
        this.$emit('allRecordsSelected');
      },
      translateIfOptionString(option) {
        return typeof option === 'string' ? this.I18n.t(option) : option;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/filters.vue?6ba669f9